import DashboardLayout from "@/layouts/dashboard-layout";
import "./styles.scss";
import { Trophy, One, Two, Three, Timer } from "@/assets";
import { motion } from "framer-motion";
import leaderboard from "@/assets/leaderboard.png";
import avatar from "@/image/user2.png";
import { useRef } from "react";
import { useFetchLeaderboard } from "@/services/teachers/get";
import { useAuth } from "@/contexts/auth-context";
import { leaderboardFormatTimeLeft } from "@/utils/function";
import {
  ProgressDown,
  ProgressSame,
  ProgressUp,
} from "@/assets/illustration/progress";
import { useNavigate } from "react-router-dom";

export const Leaderboard = () => {
  const listRef = useRef(null);
  const navigate = useNavigate();

  const { token } = useAuth();

  const {
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    refetch,
    isRefetching,
    error,
    isLoading,
  } = useFetchLeaderboard(token!);

  const RankIcon = ({ rank }: { rank: number }) => {
    const rankComponents = {
      1: <One />,
      2: <Two />,
      3: <Three />,
    };
    return (
      <div className="rank">
        {" "}
        {rankComponents[rank as keyof typeof rankComponents] ?? rank}
      </div>
    );
  };
  return (
    <DashboardLayout>
      {isLoading ? (
        <p>Loading</p>
      ) : data?.pages[0]?.ranks?.length < 1 || !data?.pages[0].ranks ? (
        <div>
          <span
            style={{
              fontSize: 16,
              color: "#000",
              textAlign: "center",
              marginTop: 30,
            }}
          >
            🏆 No league rank yet, champ! Complete an{" "}
            <span
              onClick={() => navigate("Activity")}
              style={{ color: "#1177B2" }}
            >
              Activity
            </span>{" "}
            to claim your spot on the leaderboard!
          </span>
        </div>
      ) : (
        <div className="leaderboard">
          <div
            className="leaderboard__header"
            style={{ backgroundImage: `url(${leaderboard})` }}
          >
            <Trophy />
            <h1 className="leaderboard__title">
              {data?.pages[0]?.league?.name}
            </h1>
            <p className="leaderboard__subtitle">
              {data?.pages[0]?.league?.subtitle}
            </p>
            <div className="leaderboard__timer">
              <Timer />
              <span>
                {leaderboardFormatTimeLeft(data?.pages[0]?.league?.endsAt)}
              </span>
            </div>
          </div>

          <div className="leaderboard__list" ref={listRef}>
            {data?.pages[0]?.ranks.map((item: any, index: number) => {
              return (
                <div>
                  <motion.div
                    key={index}
                    className={`leaderboard__card ${
                      index + 1 <= 6 ? "leaderboard__card--top" : ""
                    }`}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: index * 0.03 }}
                  >
                    <div className="leaderboard__left">
                      <RankIcon rank={item?.rank} />
                      <img
                        src={
                          item?.user?.avatarUrl ? item?.user?.avatarUrl : avatar
                        }
                        alt="avatar"
                        className="leaderboard__avatar"
                      />
                      <span className="leaderboard__name">
                        {item.isCurrentUser ? "You" : item?.user?.name}
                      </span>
                    </div>

                    <p
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 4,
                      }}
                      className="leaderboard__score"
                    >
                      {item?.score}
                      {item?.progress?.toLowerCase() === "up" ? (
                        <ProgressUp />
                      ) : item?.progress?.toLowerCase() === "down" ? (
                        <ProgressDown />
                      ) : (
                        <ProgressSame />
                      )}
                    </p>
                  </motion.div>

                  {item.rank === data?.pages[0]?.zones.promotion.toRank && (
                    <div className="leaderboard__line">
                      <div className="leaderboard__left-line" />
                      <div className="leaderboard__named">
                        {`Promotion Zone`}
                      </div>
                      <div className="leaderboard__right-line" />
                    </div>
                  )}
                  {item.rank === data?.pages[0]?.zones?.demotion?.fromRank && (
                    <div className="leaderboard__line-demotion">
                      <div className="leaderboard__left-line-demotion" />
                      <div className="leaderboard__named-demotion">
                        {`Relegation Zone`}
                      </div>
                      <div className="leaderboard__right-line-demotion" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};
